import type { ActionStatus } from '../lib/types'
import { ACTION_REASON_LABEL, ACTION_REASONS_BY_STATUS, REASON_REQUIRED } from '../lib/format'

/** O motivo atual ainda vale para o status escolhido? (senão, zera ao trocar). */
export function reasonFitsStatus(status: ActionStatus, reason: string | null): boolean {
  return !!reason && (ACTION_REASONS_BY_STATUS[status] ?? []).includes(reason)
}

/** Falta o motivo obrigatório? ("Não fiz" exige — é 1 clique.) */
export function reasonMissing(status: ActionStatus, reason: string | null): boolean {
  return REASON_REQUIRED.includes(status) && !reasonFitsStatus(status, reason)
}

/**
 * Motivo em 1 clique ao marcar "Não fiz" / "Fiz diferente". Diz à IA se a ação não
 * serve para o cliente ("Discordo", "Cliente não aprovou") ou só não coube na semana.
 */
export function ReasonChips({
  status,
  value,
  onChange,
}: {
  status: ActionStatus
  value: string | null
  onChange: (reason: string | null) => void
}) {
  const options = ACTION_REASONS_BY_STATUS[status]
  if (!options) return null
  const required = REASON_REQUIRED.includes(status)
  return (
    <div className="mt-2">
      <p className="mb-1 text-xs font-medium text-slate-500">
        Por quê?{' '}
        {required ? (
          <span className="text-rose-600">(escolha um — ensina a IA)</span>
        ) : (
          <span className="text-slate-400">(opcional)</span>
        )}
      </p>
      <div className="flex flex-wrap gap-1.5">
        {options.map((r) => {
          const active = value === r
          return (
            <button
              key={r}
              type="button"
              onClick={() => onChange(active ? null : r)}
              aria-pressed={active}
              className={`rounded-full border px-2.5 py-1 text-xs font-medium transition ${
                active
                  ? 'border-brand-600 bg-brand-600 text-white'
                  : 'border-slate-300 bg-white text-slate-600 hover:border-brand-400 hover:text-brand-700'
              }`}
            >
              {ACTION_REASON_LABEL[r]}
            </button>
          )
        })}
      </div>
    </div>
  )
}
